module.exports = __webpack_public_path__ + "img/video408.4061fdd6.jpg";